import { Alert } from "antd";
import React, { useContext, useEffect } from "react";
import FullScreenLayout from "../../layouts/FullScreenLayout";
import { Actions } from "../Store/Reducer";
import { StoreContext } from "../Store/Store";
import axios from "axios";

export const loadVarsJson = async ({ setIsLoading, setIsError }) => {
  if (setIsError) setIsError(null);
  if (setIsLoading) setIsLoading(true);
  let result;
  try {
    const response = await axios(`/vars.json`);
    if (!response.data.Mqtt) throw new Error("Load vars error.");
    result = response.data;
  } catch (error) {
    if (setIsError) setIsError(error.message);
  }
  if (setIsLoading) setIsLoading(false);
  return result;
};

const VarsProvider = ({ children }) => {
  const [store, dispatch] = useContext(StoreContext);
  const setIsLoading = (isLoading) =>
    dispatch({ type: Actions.SetVarsLoading, payload: isLoading });
  const setIsError = (error) =>
    dispatch({ type: Actions.SetVarsError, payload: error });

  // load vars.json
  useEffect(() => {
    (async () => {
      let config = await loadVarsJson({ setIsLoading, setIsError });
      dispatch({ type: Actions.SetVars, payload: config });
    })();
  }, []);

  let contents = children;
  if (store.vars === null || store.varsLoading) {
    contents = (
      <FullScreenLayout>
        <div></div>
      </FullScreenLayout>
    );
  }
  if (store.varsError) {
    contents = (
      <FullScreenLayout>
        <Alert message={store.varsError} type="error" showIcon />
      </FullScreenLayout>
    );
  }
  return <div>{contents}</div>;
};

export default VarsProvider;
